/* https://github.com/namespace-ee/react-calendar-timeline/issues/134#issuecomment-314215244 */
import React from "react"
import { connect } from "react-redux"
import {
  compose,
  defaultProps,
  shouldUpdate,
  withStateHandlers,
  withPropsOnChange,
  branch,
  pure,
} from "recompact"
import { EyesOnIcon } from "@infotech/uikit-icons"
import makeCompareFunction from "src/helpers/makeCompareFunction"
import planResourceTypes from "src/hocs/planResourceTypes"
import resourceTypes from "src/hocs/resourceTypes"
import { withRouter } from "react-router-dom"
import { LAYER_HEIGHT } from "src/containers/Calendar/constants"
import { requestValidate } from "src/engine/modules/validate/actions/creators"
import selectValidate, {
  selectViolationsList,
} from "src/engine/modules/validate/selectors"
import { selectValue } from "src/engine/modules/ui/selectors"
import { creators } from "src/engine/modules/entity/actions"

import get from "lodash/get"
import isEmpty from "lodash/isEmpty"

import planModel from "src/models/plan"
import ResourceGroup from "./ResourceGroup"
import CardOverlay from "./CardOverlay"
import Timeline from "./Timeline"
import Header from "./Header"
import EventCard from "./CardOverlay/eventCard"
import CardProxy from "./CardOverlay/CardProxy"
import EmptyOverlay from "./EmptyOverlay"
// eslint-disable-next-line import/no-named-as-default,import/no-named-as-default-member
import FirstCreationFiller from "./EmptyOverlay/fillers/FirstCreationFiller"
import PendingFiller from "./EmptyOverlay/fillers/PendingFiller"
import withGroupHiding from "./hocs/withGroupHiding"

import styles from "./styles.css"

export default compose(
  defaultProps({
    sidebarWidth: 260,
    lineHeight: LAYER_HEIGHT,
    itemHeightRatio: 0.96,
    rightSidebarWidth: 0,
    stickyHeader: true,
    stickyOffset: `110px`,
    stackItems: true,
    useLayers: true,
    canMove: true,
    dragSnap: 1000 * 60 * 5, // 5 minutes
    headerLabelGroupHeight: 0,
    itemTouchSendsClick: true,
  }),

  connect(
    state => ({
      planAllValidate: selectValidate(state),
      planAllResourcesValidate: selectViolationsList(
        state,
        `resourceViolations`,
      ),
      areMenuCaptionsVisible: selectValue(state, `areMenuCaptionsVisible`),
    }),
    (dispatch, props) => {
      const data = get(props, `plan.data`)
      return {
        togglePlanLock: () =>
          dispatch(
            creators.update.success(planModel, get(data, `id`), {
              ...data,
              locked: !get(data, `locked`),
            }),
          ),
        requestValidate,
      }
    },
  ),

  // @TODO: Rows hover markup is disabled here, need deep fixes
  /* withHandlers({
    onRowHover: props => (rowIndex, mouseIn, ...rest) => {
      const sidebarRow = document.querySelectorAll(`.rct-sidebar-row`)[rowIndex].firstChild
      const hoverBar = sidebarRow.lastChild
      if (mouseIn) {
        hoverBar.classList.add(styles.ActiveHoverbar)
      } else {
        hoverBar.classList.remove(styles.ActiveHoverbar)
      }
      props.onRowHover && props.onRowHover(rowIndex, mouseIn, ...rest)
    },
  }), */

  shouldUpdate((props, { hold }) => !hold),

  withStateHandlers(
    {
      selectedEvent: null,
      newEvent: null,
      hoverIndex: null,
    },
    {
      handleSelect: (n, { items }) => selectedId => ({
        selectedEvent: {
          data: items.find(({ id }) => id === selectedId),
          id: selectedId,
        },
      }),
      handleDeselect: () => () => ({
        selectedEvent: null,
      }),
      onReachEnd: (_, { loadNextPage, pending }) => () => {
        if (!pending) {
          loadNextPage()
          return null
        }
        return null
      },
      resetScrollState: () => resetOffset => {
        resetOffset(0)
        setTimeout(() => window.scrollTo(0, 0), 300)
      },
      setHoverIndex: () => index => ({
        hoverIndex: index,
      }),
    },
  ),
  /* Fetch optional resources types */
  branch(({ planId }) => !!planId, planResourceTypes(), resourceTypes()),

  withGroupHiding,

  withPropsOnChange([`groupsCache`], ({ groupsCache }) => {
    return { groups: groupsCache }
  }),

  withRouter,

  withPropsOnChange(
    makeCompareFunction([`match.url`]),
    ({ resetScrollState, loadNextPage }) => {
      resetScrollState(loadNextPage)
    },
  ),

  pure,
)(props => (
  <div className={styles.Calendar}>
    <CardOverlay
      CardComponent={EventCard}
      onEventRemove={props.handleEventRemove}
    >
      <Header
        onAdd={props.onAdd}
        onBack={props.onBack}
        onForward={props.onForward}
        isBackDisabled={props.isBackDisabled}
        isForwardDisabled={props.isForwardDisabled}
        topContent={props.topDockContent}
        centerContent={props.centerDockContent}
        rightContent={props.rightDockContent}
        start={props.defaultTimeStart}
        end={props.defaultTimeEnd}
        queryApi={props.queryApi}
        plan={props.plan}
        planSettingsOptions={props.planSettingsOptions}
        planAllValidate={props.planAllValidate}
        requestValidate={props.requestValidate}
        calendarPending={props.pending}
        history={props.history}
        match={props.match}
        location={props.location}
        disableCreate={!props.isEventCreationEnabled}
        planResourceTypes={props.planResourceTypes}
        resourceTypes={props.resourceTypes}
        filterCalendarBy={props.filterCalendarBy}
        resourceNameFilter={props.resourceNameFilter}
        eventCustomFieldFilter={props.eventCustomFieldFilter}
        resourceTypeIdFilter={props.resourceTypeIdFilter}
        eventTypeIdFilter={props.eventTypeIdFilter}
        statusCodeFilter={props.statusCodeFilter}
        planId={props.planId}
        eventTypes={props.eventTypes}
      />
      {/* If the plan/calendar is empty, show the first item creation page */}
      <EmptyOverlay
        inPlan={Boolean(props.plan)}
        filler={(() => {
          const {
            pending,
            groups,
            plan,
            onAdd,
            displayLoaderOverlay,
            areMenuCaptionsVisible,
            togglePlanLock,
            resourceNameFilter,
            filterCalendarBy,
          } = props

          if (displayLoaderOverlay) {
            return <PendingFiller />
          }

          if (!pending && groups && !groups.length) {
            return (
              <FirstCreationFiller
                inPlan={Boolean(plan)}
                resourceNameFilter={resourceNameFilter}
                filterCalendarBy={filterCalendarBy}
                areMenuCaptionsVisible={areMenuCaptionsVisible}
                plan={plan}
                isPlanLocked={Boolean(get(plan, `data.locked`))}
                togglePlanLock={togglePlanLock}
                onAdd={onAdd}
              />
            )
          }

          return null
        })()}
      >
        <Timeline
          {...props}
          onTimeChange={(start, end, updateScrollCanvas) => {
            props.onTimeChange({
              start,
              end,
              updateScrollCanvas,
              scale: props.currentScale,
              previousRange: {
                start: props.calendarStartTime,
                end: props.calendarEndTime,
              },
            })
          }}
          groupRenderer={({ group, elementStyle }) => {
            return (
              <ResourceGroup
                group={group}
                height={elementStyle.height}
                outerProps={props}
                plan={!isEmpty(props.plan)}
                planAllResourcesValidate={props.planAllResourcesValidate}
                planResourceTypes={props.planResourceTypes}
                resourceTypes={props.resourceTypes}
                hoverIndex={props.hoverIndex}
                setHoverIndex={props.setHoverIndex}
              />
            )
          }}
          replacementHeightTop={props.replacementHeightTop}
          replacementHeightBottom={props.replacementHeightBottom}
          currentScale={props.currentScale}
          onItemDeselect={props.handleDeselect}
          onItemSelect={props.handleSelect}
          planStart={get(props, `plan.data.startDateTime`)}
          planEnd={get(props, `plan.data.endDateTime`)}
        />
      </EmptyOverlay>
      {/* TODO */}
      {/* here we check currentScale because have bug with time */}
      {props.selectedEvent && !props.eventFromStackData ? (
        <CardProxy
          key={props.selectedEvent.id}
          data={props.selectedEvent.data}
          id={props.selectedEvent.id}
          disableDelete={!props.canDeleteEvent(props.selectedEvent.data)}
          disableStatus={!props.canChangeStatus(props.selectedEvent.data)}
          CustomEditIcon={
            !props.canEditEvent(props.selectedEvent.data) ? EyesOnIcon : null
          }
        />
      ) : (
        props.selectedEvent &&
        props.eventFromStackData && (
          <CardProxy
            key={props.eventFromStackData.id}
            data={props.eventFromStackData}
            id={props.eventFromStackData.id}
            position={props.eventgroupPosition}
            planId={props.planId}
            groupCard
            canEditEvent={props.canEditEvent}
            canDeleteEvent={props.canDeleteEvent}
            canChangeStatus={props.canChangeStatus}
          />
        )
      )}
    </CardOverlay>
  </div>
))
